export default "https://cdn-static.gokick.com/assets/fd6b0a6afc37e3a7e4b7ae7c7f4dd4a202138084/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";